exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir] .number-selector{border-top:1px solid #3f3d3d;border-bottom:1px solid #3f3d3d}.number-selector .btn-selector{color:#fff;height:42px;width:40px;outline:none}[dir] .number-selector .btn-selector{background-color:#3f3d3d;border:none;cursor:pointer}[dir] .number-selector .btn-selector .fa-minus,[dir] .number-selector .btn-selector .fa-plus{padding-top:5px}.number-selector .count-container{height:100%;width:40px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/number-selector/number-selector.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/number-selector/number-selector.component.scss
// module chunks = 0